__turbopack_context__.v({
  "conditions": "ProductDrawer-module-scss-module__1Cm57W__conditions",
  "drawer": "ProductDrawer-module-scss-module__1Cm57W__drawer",
});
